import { equals, unset, when, toggle, push, set } from 'cerebral/operators'
import { props, state } from 'cerebral/tags'
import editMedia from '../actions/editMedia'
import onFilterFiles from '../actions/onFilterFiles'
import toggleFilterIndicator from '../actions/toggleFilterIndicator'
import deleteResource from './deleteResource'
import toggleRestriction from './toggleRestriction'
import getCurrentMediaId from '../actions/getCurrentMediaId'
import spliceFileResource from '../factories/spliceFileResource'

const getAllSelected = (statePath, moveToPath) => {
  return function({ state }) {
    const data = state.get(statePath)
    const selected = Object.keys(data).reduce((acc, key) => {
      const item = data[key]
      if (item.selected) {
        acc[key] = {
          ...item,
          pinned: false
        }
      }
      return acc
    }, {})
    state.set(moveToPath, selected)
  }
}

export default [
  when(state`media.tags.showShared`),
  {
    true: [
      equals(props`type`),
      {
        restriction: [...toggleRestriction],
        otherwise: [...deleteResource]
      }
    ],
    false: [
      getCurrentMediaId,
      equals(props`type`),
      {
        groups: [
          toggle(state`${props`path`}.selected`),
          when(state`${props`path`}.selected`),
          {
            true: [push(state`media.files.${props`id`}.groups`, props`value`)],
            false: [
              spliceFileResource('groups'),
              unset(state`media.tags.form.groups.${props`indexes[0]`}`)
            ]
          },
          getAllSelected('media.tags.form.allGroups', 'media.tags.form.groups'),
          editMedia
        ],
        node: [toggle(state`${props`path`}.selected`)],
        restriction: [...toggleRestriction],
        receivers: [unset(state`${props`path`}`)],
        fileTypes: [
          toggle(state`${props`path`}.selected`),
          toggleFilterIndicator,
          set(props`path`, props`path`),
          onFilterFiles,
          set(state`media.selectedFiles`, []),
          set(state`media.filter.repaint`, false)
        ],
        otherwise: [...deleteResource]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/togglePillClicked.js